import { render, staticRenderFns } from "./ReactivationPreview.vue?vue&type=template&id=528e8871&"
import script from "./ReactivationPreview.vue?vue&type=script&lang=js&"
export * from "./ReactivationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports